module.exports = __webpack_public_path__ + "static/media/Vocalo.0b4c4f2a.png";